export const FRONTEND_STATE_LOCATION_HOVERED = 'FRONTEND_STATE_LOCATION_HOVERED';
